<!-- 工作室优秀项目 -->
<template>
    <section class="indBlock titLeft">
        <div class="container">
            <div class="hd clearfix">
                <h3><a href="#">工作室优秀项目</a></h3>
                <div class="introTxt">高质量项目成果报告展示</div>
                <div class="more"><a class="btn hoverBg" href="#" v-if="false">更多</a></div>
            </div>
            <div class="bd">
                <ul class="proList clearfix">
                    <li v-for="(data, index) in projectList" :key="index">
                        <ProjectItem :data="data"></ProjectItem>
                    </li>
                </ul>
            </div>
            <div class="fd">
                <a class="btn bigBtn blueSty hoverShadow" href="#" v-if="false">更多项目成果</a>
            </div>
        </div>
    </section>
</template>
<script>
    import ProjectItem from './ProjectItem'

    export default {
        name: 'QualityProject',
        data() {
            return {
                projectList: [
                    {
                        studio: '泰迪 · 广软学院智能科学工作室',
                        project: '教育课程智能推荐策略',
                        icon: 'project_kcjy.png'
                    },
                    {
                        studio: '泰迪 · 广西科大智能工作室',
                        project: '零售商品数据分析',
                        icon: 'project_lssp.png'
                    },
                    {
                        studio: '泰迪 · 广西科大智能工作室',
                        project: '热门电影影评数据分析',
                        icon: 'project_rmdy.png'
                    },
                    {
                        studio: '泰迪 · 嘉应学院智能工作室',
                        project: '爬虫助力疫情数据追踪',
                        icon: 'project_yqsj.png'
                    },
                    {
                        studio: '泰迪 · 上商智能工作室',
                        project: '供应链销售数据分析',
                        icon: 'project_gyl.png'
                    },
                    {
                        studio: '泰迪 · 重理工智能工作室',
                        project: '用户浏览新闻行为分析',
                        icon: 'project_xw.png'
                    },
                ]
            }
        },
        components: {
            ProjectItem
        }
    }
</script>